import { Label } from '@nike/eds';
import * as luxon from 'luxon';

const ourtimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const parseDate = (timestamp: string) => {
    var dt = luxon.DateTime.fromISO(timestamp.replace(' ', 'T'), {zone: 'UTC'});
    return dt.setZone(ourtimezone);
}

interface DateTimeFormatProps {
    timestamp?: string | null;
    format?: string;
    font?: string;
}

const DateTimeFormat = ({timestamp, format = "dd/MM/yyyy HH:mm:ss", font = ''}: DateTimeFormatProps) => {
    let formatted = "";

    if (!format) {
        format = "dd/MM/yyyy HH:mm:ss";
    }

    if (timestamp) {
        const dt = parseDate(timestamp);
        formatted = dt.toFormat(format);
    }
    if (font) {
        return <Label font={font as any}>
            {formatted}
        </Label>
    }
    return <>{formatted}</>
};

export default DateTimeFormat;